import {
  ActiveFilter,
  ActiveFiltersBar,
  Input,
  TableFilter,
  TableFilters,
} from '../../../../../../components'
import { useListFilters } from '../../core/ListFiltersProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useCoordenadoresFiltrados } from '../../core/useCoordenadoresFiltrados'
import { CoordenadorClienteListToolbar } from './CoordenadorClienteListToolbar'

export const CoordenadorClienteListHeader = () => {
  const { isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const total = useCoordenadoresFiltrados().length

  // Chip da faixa "Filtros ativos": o × limpa o campo.
  const activeFilters: ActiveFilter[] = filters.busca.trim()
    ? [
        {
          key: 'busca',
          label: 'Busca',
          value: `“${filters.busca.trim()}”`,
          onRemove: () => setFilter('busca', ''),
        },
      ]
    : []

  const resultado = isLoading
    ? 'Buscando…'
    : `${total} ${total === 1 ? 'coordenador encontrado' : 'coordenadores encontrados'}`

  return (
    <div className='card-header border-0 pt-6'>
      <TableFilters
        actions={<CoordenadorClienteListToolbar />}
        footer={
          <ActiveFiltersBar filters={activeFilters} onClearAll={clearFilters} summary={resultado} />
        }
      >
        <TableFilter label='Coordenador' wide>
          <Input
            placeholder='Nome, conselho ou RQE'
            value={filters.busca}
            onChange={(e) => setFilter('busca', e.target.value)}
          />
        </TableFilter>
      </TableFilters>
    </div>
  )
}
